import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-247d14fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-loader" }

import BaseProgressBar from "../components/BaseProgressBar.vue";
import SelectScreenTextBg from "@/components/svg/SelectScreenTextBg.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLoader',
  props: {
    progress: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SelectScreenTextBg, { class: "bg" }),
    _createVNode(BaseProgressBar, { progress: _ctx.progress }, null, 8, ["progress"])
  ]))
}
}

})